import { useEffect, useState } from "react";
import { apiUrl } from "../config/api";

export function useDestinations() {
  const [destinations, setDestinations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(apiUrl("/api/destinations"))
      .then((response) => response.ok ? response.json() : Promise.reject(new Error("Unable to load destinations")))
      .then((data) => setDestinations(Array.isArray(data.destinations) ? data.destinations : []))
      .catch(() => setDestinations([]))
      .finally(() => setLoading(false));
  }, []);

  return { destinations, loading };
}

export function useDestination(slug) {
  const [destination, setDestination] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!slug) return;
    setLoading(true);
    fetch(apiUrl(`/api/destinations/${encodeURIComponent(slug)}`))
      .then((response) => response.ok ? response.json() : Promise.reject(new Error("Destination not found")))
      .then((data) => setDestination(data.destination))
      .catch(setError)
      .finally(() => setLoading(false));
  }, [slug]);

  return { destination, loading, error };
}
